import { BoxTitles } from "@boxes/BoxTitles";
import { BoxTypes } from "@boxes/BoxTypes";
import React from "react";
import { ImportedAudienceForm } from "../audience/ImportedAudienceForm";

export class AudienceGroupForm extends React.Component {
  state = {
    selectedAudience: null,
  };

  componentDidMount() {
    const { node } = this.props;
    this.setState({
      selectedAudience: node.data?.audiences?.find((f) => f.selected),
    });
  }

  componentDidUpdate(prevProps) {
    const { visible, node } = this.props;
    const { selectedAudience } = this.state;

    const audienceSelected = node.data?.audiences?.find((f) => f.selected);
    if (visible && audienceSelected?.id != selectedAudience?.id) {
      this.setState({ selectedAudience: audienceSelected });
    }
  }

  onChangeAudience(audience) {
    const { node, onChange } = this.props;
    for (const f of node.data?.audiences) {
      if (f.selected) {
        f.data = audience.data;
      }
    }
    onChange && onChange(node);
    this.setState({ selectedAudience: audience });
  }

  saveGroup(audience) {
    const { node, onSave } = this.props;

    for (const f of node.data?.audiences) {
      if (f.selected) {
        f.data = audience.data;
      }
    }
    onSave && onSave(node);
  }

  render() {
    const { visible, onClose } = this.props;
    const { selectedAudience } = this.state;

    const props = {
      title: selectedAudience?.type && BoxTitles[selectedAudience.type],
      visible: visible,
      onClose: onClose,
      node: selectedAudience,
      onChange: (n) => this.onChangeAudience(n),
      onSave: (n) => this.saveGroup(n),
    };

    switch (selectedAudience?.type) {
      case BoxTypes.SavedAudience:
        return null;
      case BoxTypes.ImportedAudience:
        return <ImportedAudienceForm {...props} />;
      default:
        return null;
    }
  }
}
